export const TRANSFER_FEE = 1.7;
